import { Box, Flex } from "@chakra-ui/react";
import React, { Fragment } from "react";
import GameTypeSelector from "../../components/v3Layout/GameTypeSelector/GameTypeSelector";
import SubListSelector from "../../components/v3Layout/SubListSelector/SubListSelector";
import PlatformSelector from "../../components/v3Layout/PlatformSelector/PlatformSelector";
import MobileSearchV2 from "../Search/mobile-search_v2";
import LiveGameSelector from "../../components/v3Layout/GameSelector/LiveGameSelector";
import Seo from "./seo";
import MarqueeListV2 from "../../components/marquee/marqueeList_v2";

const LiveV3 = ({ gameMainTypeFromProps } = {}) => {
  return (
    <Fragment>
      <Seo />
      <Box as="section" px="common-y">
        <MarqueeListV2 />
      </Box>

      <Box>
        <MobileSearchV2 listHidden />
      </Box>
      <Flex>
        <Box pl="common-y" pr="5px">
          <GameTypeSelector gameMainTypeFromProps={gameMainTypeFromProps} />
        </Box>
        <Box
          overflowY="scroll"
          flex={1}
          // h={{
          //   base: "80vh",
          //   md: "auto",
          // }}
        >
          {/* <Box
            mt={{
              md: "0px",
              base: "10px",
            }}
          >
            <MobileSearchV2 listHidden />
          </Box> */}
          <Box pb="common-y" px="common-y">
            <SubListSelector
              forceShowAll
              gameMainTypeFromProps={gameMainTypeFromProps}
            />
          </Box>
          <Box py="home-space" px="common-y">
            {/* <SubListSelector /> */}
            <LiveGameSelector gameMainTypeFromProps={gameMainTypeFromProps} />
          </Box>
          {/* <Box py="common-y" px="common-y">
            <PlatformSelector gameMainTypeFromProps={gameMainTypeFromProps} />
          </Box> */}
        </Box>
      </Flex>
    </Fragment>
  );
};

export default LiveV3;
